// Primitives dùng chung cho merge settings: backup filename + union/dedupe array.
// Tách từ merge-pack-settings-into-project-settings.ts (A6 refactor) — GIỮ NGUYÊN
// hành vi. Cũng được apply-tool-manifest-to-settings.ts import (qua barrel re-export).

// Generate backup filename với timestamp YYMMDD-HHMMSS để debug + restore.
// Exported: tái dùng cho apply-tool-manifest (enable/disable cũng backup trước).
// Có GIÂY (SS): 2 lần backup trong cùng phút KHÔNG overwrite snapshot trước —
// tránh mất bản backup gốc khi thao tác liên tiếp (CI/scripted).
export function backupFilename(originalPath: string): string {
  const d = new Date();
  const stamp = `${
    d.getFullYear().toString().slice(-2) +
    String(d.getMonth() + 1).padStart(2, "0") +
    String(d.getDate()).padStart(2, "0")
  }-${String(d.getHours()).padStart(2, "0")}${String(d.getMinutes()).padStart(2, "0")}${String(
    d.getSeconds(),
  ).padStart(2, "0")}`;
  return `${originalPath}.backup-${stamp}`;
}

// Dedupe + union 2 arrays giữ thứ tự (first occurrence wins).
// Exported: tái dùng cho apply-tool-manifest (union deny + dedupe hooks).
export function unionDedupe<T>(a: T[], b: T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const item of [...a, ...b]) {
    const key = typeof item === "string" ? item : JSON.stringify(item);
    if (!seen.has(key)) {
      seen.add(key);
      out.push(item);
    }
  }
  return out;
}
